export default __webpack_public_path__ + "static/media/emoji_small.1fa0afa0.svg";